module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("Dedication")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("To my husband and best friend Paul")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("who is also a great editor and")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("the most patient person on earth")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Let us celebrate the occasion with wine and\n            sweet words.”")]), _vm._v(" —Plautus")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("and to our son")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Paul Michael")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("who "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("knows")]), _vm._v(" his mama’s all out of\n            bubblegum!")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("And to")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Mary Kay and David Baumgartner,")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("god daughter and god son-in-law")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("June 19, 2015")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("Your lives are a story.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Write a good one.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("We love you very much!")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e769733a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Dedication.vue
// module id = 72
// module chunks = 0